// modules/BackButton.js
import React            from 'react';
import { Link }         from 'react-router'
import Arrow      from '../images/arrow';

class BackButton extends React.Component {
	render() {
		return (
			<Link to={this.props.link} className="stage-return-button">
				<div className={this.props.bclass}>
					<div className="back-button-text"><Arrow/>{this.props.children}</div>
				</div>
			</Link>
		);
	}
}

export default BackButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/BackButton.js
 **/